import { differenceInCalendarDays, format } from "date-fns";

// Formats a turn timestamp for the message-time indicator, e.g.
// "Yesterday, 5:52 PM". Buckets by calendar day relative to `now` (defaults to
// the current time) and renders in the runtime's local time zone, so the label
// reads naturally in the viewer's browser. Returns "" for an unparseable input.
export function formatTurnTime(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";

  const days = differenceInCalendarDays(now, date);
  let day: string;
  if (days === 0) day = "Today";
  else if (days === 1) day = "Yesterday";
  else if (days > 1 && days < 7) day = format(date, "EEEE");
  else day = format(date, date.getFullYear() === now.getFullYear() ? "MMM d" : "MMM d, yyyy");

  return `${day}, ${format(date, "h:mm a")}`;
}
